export const YNReturn = (value) => {
	let bool = 'N';

	if(value !== 'undefined' && value !== null) {
		if(typeof value === 'boolean') {
			bool = value ? 'Y' : 'N';
		}

		if(typeof value === 'string') {
			if(value.length === 1) {
				bool = value.toUpperCase() === 'N' ? 'N' : 'Y';
			}

			if(value.toUpperCase() === 'TRUE') {
				bool = 'Y';
			}

			if(value.toUpperCase() === 'FALSE') {
				bool = 'N';
			}
		}
	}

	return bool;
};

export const TrueFalseReturn = (value) => {
	let bool = false;

	if(value !== 'undefined' && value !== null) {
		if(typeof value === 'string') {
			if(value.length === 1) {
				bool = value.toUpperCase() === 'N' ? false : true;
			}

			if(value.toUpperCase() === 'TRUE') {
				bool = true;
			}

			if(value.toUpperCase() === 'FALSE') {
				bool = false;
			}
		} else if(typeof value === 'boolean') {
			bool = value;
		}
	}

	return bool;
}
